import { colorSystem } from "goi_common";

const title = "수도권 장례 정보 안내 - [고이장례연구소]";
const regionTitle = "서울, 인천, 경기 지역";

export const parlorRegion = {
  defaultMetaData: {
    pageOgTitle: title,
    pageDescription: `${regionTitle} 장례식장 비용, 빈소 정보, 가장 저렴한 ${title} 장례식장 비용 정보, 장례식장 비교 견적, 혜택 정보 - 고이장례연구소`,
    pageKeywords:
      "서울 장례식장 추천, 인천 장례식장 추천, 경기 장례식장 추천, 장례, 장례식, 가족장, 무빈소장례, 장례지도사, 장례식장, 장례 비용, 상조, 상조 회사, 상조회, 상조가입, 상조추천, 후불제상조, 장례상조, 상조서비스, 장례식 절차, 장례 절차, 임종, 고인, 빈소, 임종",
    pageOgDescription: `${regionTitle} 장례식장 비용, 빈소 정보, 가장 저렴한 ${title} 장례식장 비용 정보, 장례식장 비교 견적, 혜택 정보 - 고이장례연구소`,
    pageOgImage: "",
  },

  layout: {
    headTitle: title,
    layoutStyle: {
      background: "white",
      borderBottom: "1px solid #7d7d7d",
      color: "black",
      height: "60px",
    },
    ctaButtonStyle: {
      border: "none",
      color: "white",
      background: colorSystem.blue.c400,
    },
  },

  targetSidos: ["11", "31", "23"],

  regionColor: colorSystem.blue,

  bestParlorIds: [1, 39, 519, 580, 651],

  baseUrl: "https://www.metropolitan-funeral.co.kr",
};
